import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import styles from "./TodoIcon.module.scss";

const TodoIcon = () => {
  return (
    <li className={`${styles.item} header-svg-icon`}>
      <span className="header-left-todo">
        <Link
          className={styles.link}
          to={`${""}/todo-app/todo/Dubai`}
        >
          <Pencil size={14} color="#404040e6" />
        </Link>
      </span>
    </li>
  );
};

export default TodoIcon;
